<template>
  <div class="components_warp" >
        <div class="top-container">
          <div class="time">
            <i class="el-icon-time"></i> {{ min }}:{{ sec }}
          </div>
          <div v-for="(topic, index) in topics" :key="index">
            <div class="" v-if="index == curIndex">
              <div v-if="index == 0">
                <div class="text_bewrite2">
                  <p style="">
                    {{ topic.topic }}
                  </p>
                </div>
                <section class="music">
                  <div class="music_list">
                    <p>音频1</p>
                   <vue-audio :file="topic.img[11]" />
                  </div>
                  <div class="music_list">
                    <p>音频2</p>
                    <vue-audio :file="topic.img[12]" />
                  </div>
                  <div class="music_list">
                    <p>音频3</p>
                    <vue-audio :file="topic.img[13]" />
                  </div>
                </section>
                <section class="light">
                  <label v-for="(t, index) in topic.options" :key="index">
                    <input class="radio_btn" type="radio" name="light" v-model="radioVal" :value="t.optOrder"/>
                    <span class="design"></span>
                    <span class="text">{{ letterArr[index]}}</span>
                    <span style="font-size: 20px;position: relative;top:-2px">{{ t.optTxt }}</span>
                  </label>
                </section>
              </div>
              <div v-if="index == 1">
                <div class="text_bewrite2">
                  <p>
                    {{ topic.topic }}
                  </p>
                </div>
                <section class="music">
                  <div class="music_list">
                    <p>音频</p>
                    <vue-audio :file="topic.img" />
                  </div>
                </section>
                <section class="light">
                  <label v-for="(t, index) in topic.options" :key="index">
                    <input class="radio_btn" type="radio" name="light" v-model="radioVal" :value="t.optOrder" />
                    <span class="design"></span>
                    <span class="text"
                      >{{ letterArr[index] }} {{ t.optTxt }}</span
                    >
                  </label>
                </section>
              </div>
              <div v-if="index == 2">
                <div class="text_bewrite2">
                  <p>
                    {{ topic.topic }}
                  </p>
                </div>
                <section class="music">
                  <div class="music_list">
                    <p>音频</p>
                    <vue-audio :file="topic.img" />
                  </div>
                </section>
                <section class="light">
                  <label v-for="(t, index) in topic.options" :key="index">
                    <input class="radio_btn" type="radio" name="light" v-model="radioVal" :value="t.optOrder" />
                    <span class="design"></span>
                    <span class="text"
                      >{{ letterArr[index] }} {{ t.optTxt }}</span
                    >
                    <img
                      :src="t.optImg"
                      alt=""
                      style="height: 40px"
                    />
                  </label>
                </section>
              </div>

              <div v-if="index == 3">
                <div class="text_bewrite2">
                  <p>
                    {{ topic.topic }}
                  </p>
                </div>
                <section class="music">
                  <div class="music_list">
                    <p>音频</p>
                    <vue-audio :file="topic.img" />
                    <span style="color:red;margin-left: 10px">注意：此题音乐片段较长，约1分钟，请全部听完后再进行作答</span>
                  </div>
                </section>
                <section class="light">
                  <label v-for="(t, index) in topic.options" :key="index">
                    <input class="radio_btn" type="radio" name="light" v-model="radioVal" :value="t.optOrder" />
                    <span class="design"></span>
                    <span class="text"
                      >{{ letterArr[index] }} {{ t.optTxt }}</span
                    >
                  </label>
                </section>
              </div>
              <div v-if="index == 4">
                <div class="text_bewrite2">
                  <p>
                    {{ topic.topic }}
                  </p>
                </div>
                <section class="music">
                  <div class="music_list">
                    <p>音频1</p>
                    <vue-audio :file="topic.img[51]" />
                  </div>
                  <div class="music_list">
                    <p>音频2</p>
                    <vue-audio :file="topic.img[52]" />
                  </div>
                  <div class="music_list">
                    <p>音频3</p>
                    <vue-audio :file="topic.img[53]" />
                  </div>
                </section>
                <section class="light">
                  <label v-for="(t, index) in topic.options" :key="index">
                    <input class="radio_btn" type="radio" name="light" v-model="radioVal" :value="t.optOrder" />
                    <span class="design"></span>
                    <span class="text"
                      >{{ letterArr[index] }} {{ t.optTxt }}</span
                    >
                  </label>
                </section>
              </div>

              <div v-if="index == 5">
                <div class="text_bewrite2">
                  <p>
                    {{ topic.topic }}
                  </p>
                </div>
                <section class="music">
                  <div class="music_list">
                    <p>音频</p>
                    <vue-audio :file="topic.img" />
                  </div>
                </section>
                <section class="light">
                  <label v-for="(t, index) in topic.options" :key="index">
                    <input class="radio_btn" type="radio" name="light" v-model="radioVal" :value="t.optOrder" />
                    <span class="design"></span>
                    <span class="text"
                      >{{ letterArr[index] }} {{ t.optTxt }}</span
                    >
                  </label>
                </section>
              </div>
              <div v-if="index == 6">
                <div class="text_bewrite2">
                  <p>
                    {{ topic.topic }}
                  </p>
                </div>
                <section class="music">
                  <div class="music_list">
                    <p>音频</p>
                    <vue-audio :file="topic.img" />
                  </div>
                </section>
                <section class="light">
                  <ul  style="justify-content: space-between;">
                    <li  v-for="(t, index) in topic.options" :key="index">
                      <div>
                        <img
                          :src="t.optImg"
                          alt=""
                          style="width: 100px; height: 100px; margin-left:0px"
                        />
                        <div class="p">{{letterArr2[index]}}</div>
                      </div>
                      <div>
                        <label class="label">
                          <input class="radio_btn radio_btn2" type="radio" name="light" v-model="radioVal" :value="t.optOrder" />
                          <span class="design design2"></span>
                        </label>
                      </div>
                    </li>
                  </ul>
                </section>
              </div>
               <div v-if="index == 7">
                <div class="text_bewrite2">
                  <p>
                    {{ topic.topic }}
                  </p>
                </div>
                <section class="music">
                  <div class="music_list">
                    <p>音频</p>
                    <vue-audio :file="topic.img" />
                  </div>
                </section>
                <section class="light">
                  <ul >
                    <li  v-for="(t, index) in topic.options" :key="index">
                      <div>
                        <img
                          :src="t.optImg"
                          alt=""
                          style="width: 100px; height: 100px; margin-left:0px"
                        />
                        <div class="p">{{letterArr2[index]}}</div>
                      </div>
                      <div>
                        <label class="label">
                          <input class="radio_btn radio_btn2" type="radio" name="light" v-model="radioVal" :value="t.optOrder" />
                          <span class="design design2"></span>
                        </label>
                      </div>
                    </li>
                  </ul>
                </section>
              </div>

               <div v-if="index == 8">
                <div class="text_bewrite2">
                  <p>
                    {{ topic.topic }}
                  </p>
                </div>
                <section class="music">
                  <div class="music_list">
                    <p>音频</p>
                    <vue-audio :file="topic.img" />
                  </div>
                </section>
                <section class="light">
                   <label v-for="(t, index) in topic.options" :key="index">
                    <input class="radio_btn" type="radio" name="light" v-model="radioVal" :value="t.optOrder" />
                    <span class="design"></span>
                    <span class="text"
                      >{{ letterArr[index] }} {{ t.optTxt }}</span
                    >
                  </label>
                </section>
              </div>
              <div v-if="index == 9">
                <div class="text_bewrite2">
                  <p>
                    {{ topic.topic }}
                  </p>
                </div>
                <section class="music">
                  <div class="music_list">
                    <p>音频</p>
                    <vue-audio :file="topic.img" />
                  </div>
                </section>
                <section class="light">
                   <label v-for="(t, index) in topic.options" :key="index">
                    <input class="radio_btn" type="radio" name="light" v-model="radioVal" :value="t.optOrder" />
                    <span class="design"></span>
                    <span class="text"
                      >{{ letterArr[index] }} {{ t.optTxt }}</span
                    >
                  </label>
                </section>
              </div>
              
            </div>
            
          </div>
          
        </div>
        <div class="btn_warp">
          <!-- <button><router-link to="/yuyanbiaodadati">确定</router-link></button> -->
          <span></span>
          <button @click="next">确定</button>
          <span
            ><em>{{ curIndex + 1 }}</em
            >/{{ topics.length }}</span
          >
        </div>
  </div>
</template>

<script>
import VueAudio from 'vue-audio';
export default {
    data(){
        return{
            min:'',
            sec:'',
            end:'',
            startTime:'',
            endTime:'',
            clearTime:'',
            tempTime:'',
            curTempTime:'',
            curIndex: 0,
            topics: [],
            answers:[],
            name: this.$route.query.name,
            radioVal:'',
            letterArr: ["A、", "B、", "C、", "D、", "E、", "F、", "G、", "H、", "I、"],
            letterArr2:["A", "B", "C", "D", "E", "F", "G", "H", "I"],
            url:{path:'/careerevalution/navigation',query: { part:'2'}},
            url2: {
              path: "/careerevalution/guide",
              query: { name: "znsp", part: "znsp101" },
            },
            file1_1:require("../../../../../public/mp3/ceshi.mp3"),
    //   file1_2:require("../../../../../public/mp3/1_2.mp3"),
    //   file1_3:require("../../../../../public/mp3/1_3.mp3"),
    //   file2:require("../../../../../public/mp3/2.mp3"),
    //   file3:require("../../../../../public/mp3/3.mp3"),
    //   file4:require("../../../../../public/mp3/4.mp3"),
    //   file5_1:require("../../../../../public/mp3/5_1.mp3"),
    //   file5_2:require("../../../../../public/mp3/5_2.mp3"),
    //   file5_3:require("../../../../../public/mp3/5_3.mp3"),
    //   file6:require("../../../../../public/mp3/6.mp3"),
    //   file7:require("../../../../../public/mp3/7.mp3"),
    //   file8:require("../../../../../public/mp3/8.mp3"),
    //   file9:require("../../../../../public/mp3/9.mp3"),
    //   file10:require("../../../../../public/mp3/10.mp3"),
        }
    },
    components:{
        VueAudio
    },
    created() {
    this.getTopicApi();
  },
  destroyed(){
     clearTimeout(this.clearTime) // 清除
  },
   mounted(){
    this.startTime = new Date().getTime();
    this.end = Date.parse(new Date()) + 720000 // 截止时间为7分钟（1min为60000ms,）
    this.countdown()

  },
  updated() {
      this.tabAudio()
  },
  methods: {
    countdown () {
      const end = this.end
      const now = Date.parse(new Date())
      const msec = end - now
      if(msec<0) return;

    //  let day = parseInt(msec / 1000 / 60 / 60 / 24)
    //  let hr = parseInt(msec / 1000 / 60 / 60 % 24)
      let min = parseInt(msec / 1000 / 60 % 60)
      let sec = parseInt(msec / 1000 % 60)
    //  this.day = day
    //  this.hr = hr > 9 ? hr : '0' + hr
      this.min = min > 9 ? min : '0' + min
      this.sec = sec > 9 ? sec : '0' + sec
      const that = this
      if(min>=0 && sec>=0){
        //倒计时结束
        if(min==0 && sec==0){
          this.saveNode(3,11,()=>{
          this.submit()
        })
          this.$router.push({
          path: "/brainIndex",
          query: {
            name: "xlss",
          },
        });
          console.log("倒计时结束")
        }
       this.clearTime = setTimeout(function () {
          that.countdown()
        }, 1000)
      }
    },
    getTopicApi() {
      this.$ajax
        .post(
          `${this.G_capi}${this.ports.careerEvaluation.znsp.yinyuenlList1}`,
          {},
          {
            headers: {
              token: sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.topics = res.data.data;
          this.$nextTick(()=>{
            this.tabAudio()
          })
        });
    },
    next() {

       if(this.radioVal == ''){
        this.$message.error('请选择答案')
        return false
      }

      this.curTempTime = new Date().getTime();
      if(this.radioVal == 1){
        this.answers.push({
          questionId:this.topics[this.curIndex].id,
          time:this.curTempTime,
          answer:'A'
        })
      }else if(this.radioVal == 2){
        this.answers.push({
          questionId:this.topics[this.curIndex].id,
          time:this.curTempTime,
          answer:'B'
        })
      }else if(this.radioVal == 3){
        this.answers.push({
          questionId:this.topics[this.curIndex].id,
          time:this.curTempTime,
          answer:'C'
        })
      }else if(this.radioVal == 4){
        this.answers.push({
          questionId:this.topics[this.curIndex].id,
          time:this.curTempTime,
          answer:'D'
        })
      }
      this.radioVal = ''
      if (this.curIndex + 1 < this.topics.length) {
        this.curIndex++;
      } else {
        this.saveNode(3,11,()=>{
          this.submit()
        })
      }
    },
    submit(){ //提交
      this.endTime = new Date().getTime();//结束时间
      this.tempTime = Number(this.endTime) - Number(this.startTime);
      this.$ajax.post(`${this.G_capi}${this.ports.careerEvaluation.znsp.yinyuenlAdd1}`,{
          testId:sessionStorage.getItem('testId'),
          time:this.tempTime,
          answers:this.answers,
      },{
            headers:{
              token:sessionStorage.getItem('token')
            }
        })
        .then((res) => {
            var data = res.data;
          if(data.code==2000){
            this.$router.push({
              path: "/careerevalution/success",
              query: {
                type: "answer",
                url:this.url,
                part:true
              },
            });
          }
        })
    },
    tabAudio(){
    // 获取所有audios
      var audios = document.getElementsByTagName("audio");
    // 暂停函数
      function pauseAll() {
        var self = this;
        [].forEach.call(audios, function (i) {
          // 将audios中其他的audio全部暂停
          i !== self && i.pause();
        })
      }
    // 给play事件绑定暂停函数
        [].forEach.call(audios, function (i) {
          i.addEventListener("play", pauseAll.bind(i));
        })
      }
  }
}
</script>

<style scoped>
.components_warp{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.title h4 {
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.text_bewrite2 p {
  font-size: 16px;
  font-weight: 600;
  font-weight: 600;
}
.btn_warp {
  /* width: 70%;
    text-align: center;
    position: absolute;
    bottom:70px; */
  display: flex;
  justify-content: space-between;
}

/* 按钮 */
.btn_warp button {
  width: 166px;
  height: 41px;
  background: linear-gradient(90deg, #1fd99c 0%, #1ac6fd 100%);
  border-radius: 21px;
  border: none;
  color: #fff;
  font-size: 18px;
  margin: 40px auto 0;
  display: block;
}


.btn_warp em {
  font-style: normal;
  color: red;
}
.btn_warp span {
    font-size: 18px;
  /* position: relative;
    right: -250px; */
  display: block;
  flex: 1;
  text-align: right;
  margin-top: 40px;
  line-height: 41px;
}

/* 单选按钮 */

.light {
  --primary: #29d3ec;
  --other: #29d3ec;
  margin-top: 30px;
}
.light .p{
  text-align: center;
  line-height: 50px;
}
.light img {
  margin-left: 15px;
}
.light ul{
  display: flex;
  
}
.light ul li{
  margin-right: 40px;
}
.dark {
  --primary: hsl(1, 100%, 68%);
  --other: hsl(0, 0%, 90%);
  background: hsl(0, 0%, 10%);
}

/* h1 */
h1 {
  color: var(--other);
  padding: 8px 4px;
  border-bottom: 2px solid var(--other);
}

/* label */
label {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  margin: 12px 0;
  height: 40px;
  background: hsl(0, 0%, 98%);
  cursor: pointer;
  position: relative;
  padding: 0 15px;
  border-radius: 8px;
}
.label{
  background: none;
  padding: 0;
  margin: 0;
  height: auto;
}
/* input */
.radio_btn {
  opacity: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: -1;
}
.radio_btn2{
  position:static;
}
/* .design */
.design {
  width: 16px;
  height: 16px;
  border: 1px solid var(--other);
  border-radius: 100%;
  margin-right: 16px;
  position: relative;
}
.design2 {
  margin-right: 0;
  left:28px;
  top:-4px;
}
.design::before,
.design::after {
  content: "";
  display: block;

  width: inherit;
  height: inherit;

  border-radius: inherit;

  position: absolute;
  -webkit-transform: scale(0);
  transform: scale(0);
  -webkit-transform-origin: center center;
  transform-origin: center center;
}

.design:before {
  background: var(--other);
  opacity: 0;
  transition: 0.3s;
}

.design::after {
  background: var(--primary);
  opacity: 0.4;
  transition: 0.6s;
}

/* .text */
.text {
  color: #333;
  /* font-weight: bold; */
}

/* checked state */
.radio_btn:checked + .design::before {
  opacity: 1;
  -webkit-transform: scale(0.6);
  transform: scale(0.6);
}

.music {
  margin-top: 15px;
}
.music_list {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  padding: 5px 15px;
}

.time {
  position: absolute;
  top: 40px;
  right: 40px;
  color: red;
}
</style>
